module.exports = __webpack_public_path__ + "static/media/link-assembly-mr-card-back.35aa03c4.jpeg";